import { render, staticRenderFns } from "./Constituencies.vue?vue&type=template&id=5c1959c5&scoped=true&"
import script from "./Constituencies.vue?vue&type=script&lang=js&"
export * from "./Constituencies.vue?vue&type=script&lang=js&"
import style0 from "./Constituencies.vue?vue&type=style&index=0&id=5c1959c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1959c5",
  null
  
)

export default component.exports